import { useAuth0UserData } from '@gr/portal/hooks/useAuth0Custom';
import { Auth0Role } from '@gr/shared/models';
import { Redirect, Route } from 'react-router-dom';
import Roles from '../Roles';
import { PageNotFound } from './PageNotFound';

export interface ProtectedRouteProps {
  component: any;
  roles?: Auth0Role[];
  [x: string]: any;
}

const ProtectedRoute = ({ component: Component, permissions, roles, ...rest }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth0UserData();

  if (isLoading) {
    return <div>Loading Protected Route ...</div>;
  }
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated && roles) {
          return (
            <Roles roles={roles} fallback={<PageNotFound />}>
              <Component {...props} />
            </Roles>
          );
        }

        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
};

export { ProtectedRoute };

